<template>
    <div class="compare-items" v-if="selectedVariations.length > 0" v-bind:class="{collapsed: collapsed}">
        <div class="title">
            <h4>Compare products {{selectedVariations.length}} of 10</h4>
            <span class="toggle-collapse" v-on:click="toggleClass">Show</span>
        </div>
        <div class="items">
            <div v-for="product in selectedVariations" v-bind:key="product.id" class="item">
                <div class="image"><img v-bind:src="product.image_url"/></div>
                <div class="sku" v-text="product.sku"></div>
                <span class="remove" @click="remove(product)">Remove</span>
            </div>
        </div>
        <div class="actions">
            <a class="compareAll" target="_blank" v-if="selectedVariations"
               v-bind:href="generateCompareLink()">Compare</a>
            <span class="removeAll" v-on:click="removeAll">Remove All</span>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'ProductList',
    props: {
      variations: Array,
      initialCategory: String,
      initialIndustry: String,
      returnTid: String
    },
    data() {
      return {
        selectedVariations: [],
        type: '',
        collapsed: false
      }
    },
    mounted() {
      this.selectedVariations = this.variations;

    },
    watch: {
      variations: function (newVal) {
        if (this.selectedVariations.length > 0) {
          this.type = this.selectedVariations[0].type;
        }
        this.selectedVariations = newVal;
      }
    },
    methods: {
      generateCompareLink() {
        let compareLink = '';
        let returnKey =  this.initialIndustry !== '0' ? this.initialIndustry : this.initialCategory;
        let varIds = this.selectedVariations.map(function (item) {
          return item.id;
        });

        if (varIds) {
          if (this.type === 'default_kit') {
            compareLink = '/compare-kits/' + varIds.join(',') + '/' + returnKey;
          }
          else {
            compareLink = '/compare/' + varIds.join(',') + '/' + returnKey;
          }
        }

        return compareLink;
      },
      remove(product) {
        this.selectedVariations.splice(this.selectedVariations.indexOf(product), 1);
        let varIds = this.selectedVariations.map(function (item) {
          return item.id;
        });
        this.$emit("selectCompare", varIds);
      },
      removeAll() {
        this.selectedVariations = [];
        this.$emit("selectCompare", []);
      },
      toggleClass: function () {
        this.collapsed = !this.collapsed;
      },
    }
  }
</script>
